import type { ReactNode } from "react";
import { useT } from "../i18n/index.js";

/** Centred, safe-area-padded frame shared by sign-in and register. */
export function AuthShell({
  title,
  lede,
  children,
  footer,
}: {
  title: string;
  lede: string;
  children: ReactNode;
  /** Optional: a screen whose own button says the same thing needs none. */
  footer?: ReactNode;
}) {
  return (
    <div className="pad-safe-x flex min-h-[100dvh] flex-col bg-ground">
      <div
        className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center gap-7 px-5"
        style={{
          paddingTop: "calc(var(--safe-top) + 2.5rem)",
          paddingBottom: "calc(var(--safe-bottom) + 2.5rem)",
        }}
      >
        <header className="flex flex-col gap-2">
          <Mark />
          <h1 className="font-display text-3xl leading-tight">{title}</h1>
          <p className="text-[0.9375rem] text-muted">{lede}</p>
        </header>

        {children}

        {/* Пустой подвал занимал бы строку и оставлял бы под кнопкой пустоту,
            которую глаз читает как «здесь что-то не догрузилось». */}
        {footer ? (
          <footer className="text-[0.875rem] text-muted">{footer}</footer>
        ) : null}
      </div>
    </div>
  );
}

/** The same two-circle mark as the app icon, at text size. */
function Mark() {
  const t = useT();

  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 512 512"
      role="img"
      aria-label={t("common.appName")}
      className="mb-2"
    >
      <defs>
        <clipPath id="auth-mark-left">
          <circle cx="204.4" cy="256" r="122.9" />
        </clipPath>
      </defs>
      {/* Fixed colours, not theme tokens: this is the same mark as the home
          screen icon and it should not invert when the phone goes dark. */}
      <rect width="512" height="512" rx="96" fill="#2F6B5B" />
      <g fill="#F6F8F6">
        <circle cx="204.4" cy="256" r="122.9" opacity="0.62" />
        <circle cx="307.6" cy="256" r="122.9" opacity="0.62" />
        <g clipPath="url(#auth-mark-left)">
          <circle cx="307.6" cy="256" r="122.9" />
        </g>
      </g>
    </svg>
  );
}
